import React, { useState } from "react"

import HeaderIlustracion from "../../static/header_ilustracion.svg"
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from "react-router-dom";

import { useUser } from '../../context/UserContext'


export default function Header() {
  const { usuario, logout } = useUser();
  const [open, setOpen] = useState(false);
  
  var styles = {
    bmCrossButton : {
      right: "inherit",
      left: "8px"
    },
    bmMenuWrap: {
     width: '100%'
   }
  }
  function handleMenuClick() {
    setOpen(false);
  }
  function handleStateChange(state) {
    setOpen(state.isOpen);
  }
  return ( 
    <section id="header">

      <div className="hero">
        <div className="left">
          <ScrollAnimation animateIn='bounceInUp' animateOnce={true} >
          <img src={HeaderIlustracion} alt=""/>
          </ScrollAnimation>
        </div>
        <div className="box">
          <ScrollAnimation animateIn='bounceIn' animateOnce={true} >
            <div className="body">
              <h2>Encotrá causas que <br/> 
              necesitan tu Pulso.</h2>
              <div className="desc">
                Únete y apoya causas importantes para vos sin tener que movete de tu casa.
              </div>
              <Link to="/causas" className="button">Ver causas</Link>
            </div>
          </ScrollAnimation >
        </div>
      </div>
    </section>
  )
}
